export default "__VITE_ASSET__23d6a990__"